import { z } from 'zod'

export const mappingsCsvResponseSchema = z.object({
  csv: z.string(),
})
